<mat-sidenav-container (backdropClick)="closeSlideBar()">
  <mat-sidenav position="end" [opened]="sideBarOpened" disableClose>
    <a class="topRight" (click)="closeSlideBar()"><i class="material-icons">close</i></a>
    <router-outlet name="sidebar"></router-outlet>
  </mat-sidenav>
  <mat-sidenav-content id="main">
    <section class="clamp">
      <h1 class="center">
        Statistiques
      </h1>
      <nav>
        <a routerLink="../stock" routerLinkActive="active-link">Etat des stocks VTs</a>
        <a routerLink="../porteur" routerLinkActive="active-link">Rotation des stocks VTs</a>
        <a routerLink="../rotation" routerLinkActive="active-link">Rotation des stocks de LP</a>
        <a hideIfNot="ROLE_ANETT" routerLink="../5-last-cleaning" routerLinkActive="active-link">5 derniers lavages</a>
        <a hideIfNot="ROLE_ANETT" routerLink="../cab-db-integrity" routerLinkActive="active-link">Intégrité de la base
          CAB</a>
        <a hideIfNot="ROLE_ANETT" routerLink="../conso-history" routerLinkActive="active-link">Historique des
          consommations</a>
        <a routerLink="../linge-hebergement" routerLinkActive="active-link">Linge d'hébergement</a>
      </nav>
      <div id="header">
        <div *ngIf="active != 'linge-hebergement' && searchByName" class="flex flex-wrap">
          <mat-form-field class="large">
            <mat-label>Recherche</mat-label>
            <input id="filterUser" [formControl]="filterControl" matInput placeholder="{{input_hint}}">
            <mat-icon matSuffix>search</mat-icon>
            <mat-error *ngIf="filterControl.hasError('minlength')">{{input_hint}}</mat-error>
          </mat-form-field>
          <div class="m-auto pl-5">
            <div class="mr-2">Rechercher par Nom</div>
            <mat-slide-toggle [formControl]="radioControl">Casier</mat-slide-toggle>
          </div>
          <div>
            <button *ngIf="loadButton" mat-raised-button [disabled]="loading" (click)="getStats(filterContent, true)"
              class="m-auto ml-5">
              <mat-spinner diameter="20" *ngIf="loadingSpecial"></mat-spinner>Charger les données
            </button>
          </div>
        </div>
        <div *ngIf="active == 'linge-hebergement'" class="flex flex-wrap">
          <mat-form-field class="s">
            <mat-label>Date de début</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="dateDebut" placeholder="format date : jj/mm/aaaa">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker panelClass="custom-calendar"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="s">
            <mat-label>Date de fin</mat-label>
            <input matInput [matDatepicker]="picker2" [formControl]="dateFin" placeholder="format date : jj/mm/aaaa">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2 panelClass="custom-calendar"></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="m">
            <mat-label>Période de regroupement</mat-label>
            <mat-select [formControl]="period" placeholder="Sélectionner la periode">
              <mat-option *ngFor="let group of periodGroup" [value]="group">
                {{ group }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="radio-conso pl-5">
            <div [ngClass]="!isLHActivated.value ? 'disabled' : ''">Coût</div>
            <mat-slide-toggle [formControl]="radioConso">
              {{(currentClient?.is_livraison_commande) ? "Quantité commandée" : (groupLingerie.value ? "Consommation" : "Livraison")}}
            </mat-slide-toggle>
          </div>
          <div>
            <mat-checkbox [formControl]="groupLingerie" *ngIf="lingerieActivated" class="m-auto pl-5">
              Regroupement par lingerie
            </mat-checkbox>
          </div>
          <mat-form-field class="table-filter s" *ngIf="!lingerieActivated || groupLingerie.value">
            <mat-label>Données statistiques</mat-label>
            <mat-select [formControl]="dataStats" [disabled]="!isLHActivated.value">
              <mat-option *ngFor="let data of dataStatsList" [value]="data">{{data.libelle}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div id="coef-rotation" hideIfNot="ROLE_ANETT" *ngIf="active == 'rotation' && coefRotation">
          Coef rotation : {{coefRotation}} &nbsp; Date d'arrêter : {{dateArrete | date: 'dd/MM/yyyy'}}
        </div>
        <div id="button">
          <button mat-raised-button *ngIf="active == 'linge-hebergement'" id="button-statsLH" routerLink="../stats-LH"
            matTooltip="Chambres, jours d'activités, lits, nuitées..." [disabled]="!isLHActivated.value">
            Gestion des données statistiques
          </button>
          <button mat-raised-button color="primary" [disabled]="(active == 'linge-hebergement' && !isLHActivated.value) || !canExport" (click)="export()">
            Export (XLSX)
          </button>
        </div>
      </div>
      <article *ngIf="active != 'rotation' && active != 'linge-hebergement'">
        <table mat-table [dataSource]="dataSource">
          <ng-container *ngFor="let column of columns">
            <ng-container matColumnDef="{{column.id}}">
              <th mat-header-cell *matHeaderCellDef><div class="icon-custom">{{ column.libelle }}<mat-icon *ngIf="column.id=='lavage_0'" (click)="help()" class="icon-click">help</mat-icon></div></th>
              <td mat-cell *matCellDef="let element" [ngClass]="getType(element,column)">{{ element[column.id] }}</td>
            </ng-container>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns.get(active)"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns.get(active);"></tr>
        </table>
      </article>
      <app-statistic-rotation *ngIf="active == 'rotation'" [dataSource]="dataSource"></app-statistic-rotation>
      <article class="no-content" *ngIf="filterControl.value !== '' && dataSource.data.length == 0 && !load">
        <p>Aucun résultat</p>
      </article>
      <article class="no-content" *ngIf="filterControl.value === '' && searchByName && completeTable.length === 0">
        <p><strong>Veuillez effectuer votre recherche</strong></p>
      </article>
      <div class="plus">
        <button *ngIf="dataSource.data.length < completeTable.length" mat-raised-button [disabled]="loading"
          (click)="setCompleteTable()">
          <mat-icon>control_point</mat-icon> Afficher plus
        </button>
      </div>
      <article class="no-content" *ngIf="active == 'linge-hebergement' && !isLHActivated.value">
        <p><strong>Le linge d'hébergement n'est pas activé pour le compte client sélectionné</strong></p>
      </article>
      <div class="flex justify-center" *ngIf="loading && active == 'linge-hebergement' && isLHActivated.value">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="!loading && active == 'linge-hebergement' && !currentClient?.is_livraison_commande && isLHActivated.value && groupLingerie.value"
        class="text-center">
        <div id="containerDispatch">
          <h2 class="mt-0 mb-3">
            Pourcentage des livraisons enregistrées en dispatch du {{dateDebut.value | date: 'dd/MM/yyyy'}} au {{dateFin.value | date: 'dd/MM/yyyy'}}
          </h2>
          <div id="chartDispatch"><p-chart id="chartD" type="bar" [data]="dataDispatch" [options]="optionsDispatch" *ngIf="dataDispatch && !dataDispatch.empty"></p-chart></div>
          <p *ngIf="!dataDispatch || dataDispatch.empty" class="center">Aucunes données</p>
        </div>
      </div>
      <div *ngIf="!loading && active == 'linge-hebergement' && isLHActivated.value && !groupLingerie.value"
        class="text-center">
        <div>
          <h2 class="mt-0 mb-3">
            {{radioConso.value ? (currentClient?.is_livraison_commande ? 'Quantités commandées' : 'Livraisons') : 'Coûts'}} {{dataStats.value.texte}} du
            {{dateDebut.value | date: 'dd/MM/yyyy'}} au
            {{dateFin.value | date: 'dd/MM/yyyy'}}
          </h2>
          <p-chart id="chart" type="bar" [data]="data" [options]="options" *ngIf="data && !data.empty"></p-chart>
          <p *ngIf="!data || data.empty" class="center">Aucunes données</p>
        </div>
      </div>
      <div *ngIf="!loading && active == 'linge-hebergement' && isLHActivated.value && groupLingerie.value">
        <mat-tree [dataSource]="dataLingeries" [treeControl]="treeControl" *ngIf="!loading">
          <mat-nested-tree-node *matTreeNodeDef="let lingerie">
            <div *ngIf="lingerie.data && !loading">
              <div class="mat-tree-node">
                <button type="button" mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + lingerie.lingerie.nom">
                  <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(lingerie) ? 'expand_more' : 'chevron_right'}}
                  </mat-icon>
                </button>
                <div>{{lingerie.lingerie.nom}} {{lingerie.lingerie?.types}}</div>
              </div>
              <div [class.example-tree-invisible]="!treeControl.isExpanded(lingerie)" class="content-node">
                <div class="text-center">
                  <div>
                    <h2 class="mb-3">
                      {{radioConso.value ? 'Consommations' : 'Coûts'}} {{dataStats.value.texte}} du
                      {{dateDebut.value | date: 'dd/MM/yyyy'}} au
                      {{dateFin.value | date: 'dd/MM/yyyy'}}
                    </h2>
                    <p-chart id="chart" type="bar" [data]=lingerie.data [options]="options"
                      *ngIf="lingerie.data && !lingerie.data.empty && !loading">
                    </p-chart>
                    <p *ngIf="!lingerie.data || lingerie.data.empty" class="center">Aucunes données</p>
                  </div>
                </div>
              </div>
            </div>
          </mat-nested-tree-node>
        </mat-tree>
      </div>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>